<template>
    <component :is="componentTag" v-if="component.isVisible()" :id="componentId" :style="{gridArea: compId}"
               class="cms-component" :class="[`cms-component-${component.type}`, {'selected': selected}]"
               :link="link" :bound-item="componentTag === 'cms-link' ? boundItem : undefined"
               :contenteditable="contenteditable" @input="$emit('input', $event)" @blur="$emit('blur', $event)">
        <template v-if="isDisplayingReview && component.review">
            <e-status-badge v-for="(error, index) in component.review" :key="`${compId}-${index}`" :status="error.status">
                {{error.message}}
            </e-status-badge>
        </template>

        <slot v-if="!isLiquidPluginEnabled"></slot>
        <template v-else>
            <cms-plugins-liquid-renderer :value="component.plugins.liquid.code" :item="boundItem" :key="component.plugins.liquid.id" :block="block" :component="component"
                                         :highlighted="isEditMode && selected"/>
        </template>
    </component>
</template>

<script>

// cms-component #hot-reload-debug
import CmsLink from "@/components/cms/cms-link.vue";
import BtnSelector from "@components/btn-selector.vue";
import EStatusBadge from "../../../../../vue-components/components/e-status-badge.vue";
import CmsPluginsLiquidRenderer from "@components/editor/rendering/plugins/cms-plugins-liquid-renderer.vue";

export default {
    name: `cms-component`,
    components: {CmsPluginsLiquidRenderer, EStatusBadge, BtnSelector, CmsLink},
    props: {
        component: {type: Object, required: true},
        boundItem: {type: Object},
        block: {type: Object},
        compId: {type: String},
        selected: {type: Boolean},
        align: {type: String},
        link: {type: [String, Object]},
        isChild: {type: Boolean},
        contenteditable: {type: Boolean}
    },
    data() {
        return {
            cssElement: null
        }
    },
    computed: {
        componentTag() {
            return this.link ? `cms-link` : `div`;
        },
        componentId() {
            return `${this.block.getId()}-${this.compId}`;
        },
        useBinding() {
            return this.component.useBinding && this.boundItem;
        },
        isLiquidPluginEnabled() {
            return this.component.plugins?.liquid?.active === true;
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-component {
    & + .cms-component {
        margin-top: var(--block-y-spacing);
    }
}

.cms-container.horizontal {
    .cms-component {
        & + .cms-component {
            margin-top: 0;
        }
    }
}
</style>
